/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import HospitalsHospital from './HospitalsHospital';

/**
 * The ServiceLinesBody model module.
 * @module model/ServiceLinesBody
 * @version v0.3
 */
export default class ServiceLinesBody {
  /**
   * Constructs a new <code>ServiceLinesBody</code>.
   * @alias module:model/ServiceLinesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceLinesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceLinesBody} obj Optional instance to populate.
   * @return {module:model/ServiceLinesBody} The populated <code>ServiceLinesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceLinesBody();
      if (data.hasOwnProperty('service_line'))
        obj.serviceLine = HospitalsHospital.constructFromObject(data['service_line']);
    }
    return obj;
  }
}

/**
 * @member {module:model/HospitalsHospital} serviceLine
 */
ServiceLinesBody.prototype.serviceLine = undefined;

